module.exports = __webpack_public_path__ + "img/new-participant-modal.c427523b.png";